import React from 'react'
import { asyncComponent } from '../asyncComponent'

const Rte = asyncComponent(() => import('./richTextEditor'))

class RichTextEditor extends React.Component {
  emptyValue = '<p/>'

  state = {
    value: this.props.value || ''
  }

  componentDidMount () {
    // eslint-disable-next-line promise/catch-or-return
    import('react-rte').then(rte => {
      this.emptyValue = rte.createEmptyValue().toString('html')
    })
  }

  getValue () {
    return this.state.value.toString('html')
  }

  isEmpty () {
    return this.state.value.toString('html') === this.emptyValue
  }

  // This method should be used instead of isEmpty when needing the answer during onChange in other component
  isValueEmpty (value) {
    return value.toString('html') === this.emptyValue
  }

  onChange (value) {
    this.setState({ value })
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value.toString('html'))
    }
  }

  render () {
    return <Rte value={this.state.value} onChange={value => this.onChange(value)} readOnly={this.props.readOnly} />
  }
}

export {
  RichTextEditor
}



// WEBPACK FOOTER //
// ./src/components/richTextEditor/index.js